export default __webpack_public_path__ + "static/media/logo.5cf29e35.png";